import { IDBPDatabase, openDB } from "idb"
import { DB_MENUDINO_NAME, MERCHANT_STORE_NAME } from "../constants/defaults"
import packageJson from '../../package.json'

export default class MerchantDb {
    public static getDB = async (dbName: string = DB_MENUDINO_NAME, storeName: string = MERCHANT_STORE_NAME, keyPath: string = 'id') => {
        let database: Promise<IDBPDatabase<unknown>> | undefined

        try {
            if (!('indexedDB' in window)) return undefined

            let version: number

            try {
                version = Number.parseInt(packageJson.version.replaceAll('.', ''))
            }
            catch {
                version = 1
            }

            database = openDB(dbName, version, {
                upgrade(db) {
                    if (!db.objectStoreNames.contains(storeName)) {
                        db.createObjectStore(storeName, { keyPath: keyPath })
                    }
                },
            })
        }
        catch (e) {
            const error = e as Error

            if (error.name === 'UnknownError')
                console.error('Permissão negada para acesso ao IndexedDB:', error);
            else
                console.error('Erro ao acessar o IndexedDB:', error);

            database = undefined
        }

        return database
    }
}